import { useGetStaticAssetUrl } from '@change-corgi/core/react/assets';

import { useDecisionMakerResponsePageData } from 'src/app/pages/decisionMakerResponse/details/pageContext';

export type DecisionMakerResponseAuthor = {
	displayName: string;
	title?: string;
	photoUrl?: string;
	profileUrl?: string;
};

type Result = ModelHookResult<{
	author: DecisionMakerResponseAuthor;
}>;

export function useDecisionMakerResponseByLine(): Result {
	const getStaticAssetUrl = useGetStaticAssetUrl();
	const {
		data: {
			decisionMakerResponse: {
				decisionMaker: { id, displayName, title, photo, isPerson, publiclyVisible, slug },
			},
		},
	} = useDecisionMakerResponsePageData();

	// FIXME find a better default avatar for orgs
	const defaultAvatar = isPerson ? undefined : getStaticAssetUrl('/profile-img/default-org-profile.svg');

	return {
		data: {
			author: {
				displayName,
				title: title || undefined,
				photoUrl: (!photo?.userSmall.processing ? photo?.userSmall.url : undefined) || defaultAvatar,
				profileUrl: publiclyVisible ? `/decision-makers/${encodeURIComponent(slug || id)}` : undefined,
			},
		},
	};
}
